module.exports = __webpack_public_path__ + "static/media/noun-coffee-machine-2913373-142350.cd8fd407.svg";